import React from 'react';
import { TodoItem } from '../../types/todo';
import { TODAY } from '../../utils/constants';

interface LeftoverStepProps {
  /** The leftover currently being decided on. */
  current: { id: string; item: TodoItem };
  /** Position in the queue, for the "2 of 5" counter. */
  index: number;
  total: number;
  /** Leftovers that were already finished — shown as wins, never asked about. */
  completed: Array<{ id: string; item: TodoItem }>;
  onKeep: () => void;
  onDefer: () => void;
  onDrop: () => void;
}

/**
 * First wizard step: decide what carries over from the previous plan, one task
 * at a time. Deciding in isolation keeps the choice small; the alternative — a
 * whole list of checkboxes — invites skipping the step entirely.
 */
const LeftoverStep: React.FC<LeftoverStepProps> = ({ current, index, total, completed, onKeep, onDefer, onDrop }) => (
  <div className="daily-review-step">
    <h4 className="daily-review-step-title">{TODAY.LEFTOVER_STEP_TITLE}</h4>
    <p className="daily-review-hint">{TODAY.LEFTOVER_STEP_HINT}</p>

    {completed.length > 0 && (
      <div className="daily-review-completed">
        <span className="daily-review-completed-label">{TODAY.LEFTOVER_COMPLETED}</span>
        <ul>
          {completed.map(({ id, item }) => (
            <li key={id}>✓ {item.name}</li>
          ))}
        </ul>
      </div>
    )}

    <div className="daily-review-leftover">
      <span className="daily-review-counter">{index + 1} of {total}</span>
      <p className="daily-review-leftover-name">{current.item.name}</p>
      {current.item.description && (
        <p className="daily-review-leftover-description">{current.item.description}</p>
      )}
    </div>

    <div className="daily-review-leftover-actions">
      <button className="daily-review-primary" onClick={onKeep}>{TODAY.LEFTOVER_KEEP}</button>
      <button className="daily-review-secondary" onClick={onDefer}>{TODAY.LEFTOVER_DEFER}</button>
      <button className="daily-review-secondary" onClick={onDrop}>{TODAY.LEFTOVER_DROP}</button>
    </div>
  </div>
);

export default LeftoverStep;
